import { render, staticRenderFns } from "./TenderDetails.vue?vue&type=template&id=30c078d6&scoped=true"
import script from "./TenderDetails.vue?vue&type=script&lang=js"
export * from "./TenderDetails.vue?vue&type=script&lang=js"
import style0 from "./TenderDetails.vue?vue&type=style&index=0&id=30c078d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c078d6",
  null
  
)

export default component.exports